/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import ActingAsMerchantBanner from './ActingAsMerchantBanner';
import BackToMerchantListMenuItem from './BackToMerchantListMenuItem';
import BackToWorkspaceButton from './BackToWorkspaceButton';
import EmptyMerchants from './EmptyMerchants';
import Footer from './Footer';
import MerchantInitializer from './MerchantInitializer';
import PartnerManagementBanner from './PartnerManagementBanner';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  ActingAsMerchantBanner,
  AvatarDropdown,
  AvatarName,
  BackToMerchantListMenuItem,
  BackToWorkspaceButton,
  EmptyMerchants,
  Footer,
  MerchantInitializer,
  PartnerManagementBanner,
  Question,
  SelectLang,
};
